module.exports = __webpack_public_path__ + "assets/icon_reset.593bde18.svg";